export default __webpack_public_path__ + "static/media/partner-map.04d9049c.png";